import './_four04.scss';

export default () => { };
